import notAvailableCard from 'app/static/images/notavailable-card.png'
import { ImageProps, Image as PrimeImage } from 'primereact/image'
import { useEffect, useState } from 'react'

export function Image(props: ImageProps & { fallbackImage?: string }) {
  const { fallbackImage, src, onError, ...otherProps } = props
  const [imageUrl, setImageUrl] = useState<string | undefined>()

  useEffect(() => {
    setImageUrl(src ?? notAvailableCard)
  }, [src])

  return (
    <PrimeImage
      {...otherProps}
      onError={(event) => {
        if (onError) onError(event)
        if (fallbackImage && fallbackImage === imageUrl) {
          setImageUrl(notAvailableCard)
        } else setImageUrl(fallbackImage ?? notAvailableCard)
      }}
      src={imageUrl}
    >
      {props.children}
    </PrimeImage>
  )
}
